import React, { useState, Suspense, useCallback,useEffect } from 'react';
import { Link, NavLink, useLocation,useParams } from 'react-router-dom';
import { BiLogoFacebook } from "react-icons/bi";
import { PiPhoneCall, PiInstagramLogoFill, PiYoutubeLogoFill } from "react-icons/pi";
import { MdAlternateEmail } from "react-icons/md";
import { GrLocation, GrDocumentDownload } from "react-icons/gr";
import { LuHeart } from "react-icons/lu";
import { RiLinkedinFill } from "react-icons/ri";
import { FiArrowUpRight } from "react-icons/fi";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import builerLogo from '../../../assets/images/builders/logos/logo2.svg'
import esightLogo from '../../../assets/images/esight-logo-white.png'
import projectLogo1 from '../../../assets/images/builders/projectLogo/logo1.webp'
import projectBannerImg1 from '../../../assets/images/builders/builderProjects/projectBannerImg1.webp'
import projectBannerImg2 from '../../../assets/images/builders/builderProjects/projectBannerImg2.webp'
import projectBannerImg3 from '../../../assets/images/builders/builderProjects/projectBannerImg3.webp'
import projectBannerImg4 from '../../../assets/images/builders/builderProjects/projectBannerImg4.webp'
import axios from 'axios';
import { mediaUrl,baseURL } from '../../axiosInterceptor/axiosInterceptorC';

const path = "/keralaplots/";

function BuilderProject() {
    const { companyName,id } = useParams();
    const location = useLocation();

    const isActiveProjects = () => {
        return location.pathname.includes(`/builderProjectList`) || location.pathname.includes(`/builderProject`) ;
    };

    const settings = {
        dots: false,
        infinite: false,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 1024, // Large devices
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 600, // Medium devices
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 480, // Small devices
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    };

    useEffect(() => {
        fetch_project_by_id()
        fetch_websitet_by_id();
        localStorage.setItem('companyName',companyName);
        localStorage.setItem('idval',id);
      }, []); 
      const [projectlogoImg, setProjectLogo] = useState('');
      const [bannerImageUrls,setbannerImageUrls]= useState([]);
      const [ProjectDetails,setProjectDetails]= useState('');

    const fetch_project_by_id = async () => {
        const projectid=id;
        try {
            const response = await axios.post(`${baseURL}/builder/fetch_project_by_id`, {
                projectid: projectid,
            });
            console.log(response.data)
            const projectDetails = response.data.projectDetails[0];
            const logoUrl = mediaUrl+projectDetails.project_logo;
            setProjectLogo(logoUrl)
            setProjectDetails(projectDetails)
            const bannerImages = response.data.bannerImages;
            const bannerImageUrls = bannerImages.map(image => ({
                id: image.id,
                url: mediaUrl + image.banner_images,
            }));
           setbannerImageUrls(bannerImageUrls)

        } catch (error) {
            console.error(error);
        }
    };


    const [websiteDetails,setwebsiteDetails]=useState([]);

    const fetch_websitet_by_id = async () => {
        const cleanedCompanyName = decodeURIComponent(companyName);
         console.log(cleanedCompanyName)   
         try {
         const response = await axios.post(`${baseURL}/website/fetch_websitet_by_id`, {
             company_name: cleanedCompanyName,
         });
     console.log(response.data)
 
     const websiteDetails=response.data.websiteDetails[0];        
     setwebsiteDetails({
         company_name:websiteDetails.company_name,
         logo_image:websiteDetails.logo_image,
         phone1: websiteDetails.phone_number1,
         phone2: websiteDetails.phone_number2,
         email: websiteDetails.email_id,
         address1:websiteDetails.address_line1,
         address2:websiteDetails.address_line2,
         address3:websiteDetails.address_line3,
         facebook:websiteDetails.facebook_val,
         instagram:websiteDetails.instagram_val,
         youtube:websiteDetails.linkedin_val,
         linkedin:websiteDetails.youtube_val,
         title: websiteDetails.about_title,
         experience: websiteDetails.experience_val,
         description:websiteDetails.about_description,
         });
     }
     catch (error) {
         console.error(error);
     }
 }
  return (
    <>
        <div className="navTemplate">
            <div className="container">
                <div className="navMain">
                    <div className="navCol1">
                        <a href={`${path}${companyName}`} className="navLogo">
                        {websiteDetails.logo_image ? (
                                <img src={mediaUrl + websiteDetails.logo_image} alt="Website Logo" />
                            ) : (
                                <Skeleton width={100} height={50} /> // Placeholder loading effect
                            )}
                        </a>
                    </div>
                    <div className="navCol2">
                        <div className="navLink">
                            <ul>
                                <li>
                                    <NavLink to={`${path}${companyName}`}>Home</NavLink>
                                </li>
                                <li>
                                    <NavLink to={`${path}${companyName}/builderProjectList`} className={() => (isActiveProjects() ? 'navLinkActive' : '')}>Projects</NavLink>
                                </li>
                                <li>
                                    <NavLink to={`${path}${companyName}/builderPropertyList`}>Properties</NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="navCol3">
                        <div className="navProfile">
                            <NavLink to={`${path}`} target='_blank' className="navPostproperty">Kerala Plots <FiArrowUpRight /></NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <section id="builderProject">
            <div className="container">
                <div className="builderProjectprojectHead">
                    <div className="projectLogo">
                        {projectlogoImg ? (
                                <img src={projectlogoImg} alt="Website Logo" />
                            ) : (
                                <Skeleton width={100} height={50} /> // Placeholder loading effect
                            )}
                    </div>
                </div>
                <div className="builderProjectBanner">
                <PhotoProvider>
                {bannerImageUrls.length > 0 ? (
                <Slider {...settings}>
                    {bannerImageUrls.map((image, index) => (
                        <div className="builderProjectBannerBox" key={image.id || index}>
                            <PhotoView src={image.url}>
                                <img src={image.url} alt={`Banner Image ${index + 1}`} />
                            </PhotoView>
                        </div>
                    ))}
                </Slider>
            ) : (
                <div className="bannerSkeletonLoader">
                    {[...Array(1)].map((_, index) => (
                        <div className="skeletonBanner" key={index}>
                            <Skeleton height={200} />
                        </div>
                    ))}
                </div>
            )}

                </PhotoProvider>
                </div>
                <div className="builderProjectDetails">
                    <div className="builderProjectDetailsCol1">
                        <h1>{ProjectDetails.project_name}</h1>
                        <div className="builderProjectDetailsBox">
                            <p>For inquiries :</p>
                            <ul>
                                <li>
                                <a href={`tel:+91${ProjectDetails.phone_number}`}>+91 {ProjectDetails.phone_number}</a>
                                </li>
                                <li>
                                    <a href={`tel:+91${ProjectDetails.optional_phone_number}`}>+91 {ProjectDetails.optional_phone_number}</a>
                                </li>
                            </ul>
                        </div>
                        {ProjectDetails.ebrochure_pdf && (
                        <div className="builderProjectDetailsBox">
                            <a href={mediaUrl+ProjectDetails.ebrochure_pdf} download="" className="downloadEbrochure"><GrDocumentDownload /> Download E-brochure</a>
                        </div>
                        )}
                    </div>
                    <div className="builderProjectDetailsCol2">
                        <div dangerouslySetInnerHTML={{ __html: ProjectDetails.description_val }} />
                    </div>
                </div>
            </div>
        </section>
        <div className="footerTemplate">
            <div className="container">
                <div className="footerMain">
                    <div className="footerBox1">
                        <div className="footerLogo">
                        {websiteDetails.logo_image ? (
                                <img src={mediaUrl + websiteDetails.logo_image} alt="Website Logo" />
                            ) : (
                                <Skeleton width={100} height={50} /> // Placeholder loading effect
                            )}
                        </div>
                        <div className='footerSocialLink'>
                            <Link href={websiteDetails.facebook} target='_blank' className='footerSocialLinkBox'>
                                <BiLogoFacebook />
                            </Link>
                            <Link href={websiteDetails.instagram} target='_blank' className='footerSocialLinkBox'>
                                <PiInstagramLogoFill />
                            </Link>
                            <Link href={websiteDetails.linkedin} target='_blank' className='footerSocialLinkBox'>
                                <RiLinkedinFill />
                            </Link>
                            <Link href={websiteDetails.youtube} target='_blank' className='footerSocialLinkBox'>
                                <PiYoutubeLogoFill />
                            </Link>
                        </div>
                    </div>
                    <div className="footerBox2">
                        <h2>Links</h2>
                        <ul>
                            <li>
                                <NavLink to={`${path}${companyName}`}><span></span>Home</NavLink>
                            </li>
                            <li>
                                <NavLink to={`${path}${companyName}/builderProjectList`}><span></span>Projects</NavLink>
                            </li>
                            <li>
                                <NavLink to={`${path}${companyName}/builderPropertyList`}><span></span>Properties</NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className="footerBox3">
                        <h2>Connect Us</h2>
                        <ul>
                            <li>
                                <div className='icon'>
                                    <PiPhoneCall />
                                </div>
                                <div className='contactDestails'>
                                    <Link href={`tel:+91${websiteDetails.phone1}`}>+91 {websiteDetails.phone1}</Link>
                                </div>
                            </li>
                            <li>
                                <div className='icon'>
                                    <MdAlternateEmail />
                                </div>
                                <div className='contactDestails'>
                                    <Link href={`mailto:${websiteDetails.email}`}>{websiteDetails.email}</Link>
                                </div>
                            </li>
                            <li>
                                <div className='icon'>
                                    <GrLocation />
                                </div>
                                <div className='contactDestails'>
                                <p>{websiteDetails.address1} <br/>{websiteDetails.address2}<br/>{websiteDetails.address3}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='footerStrip'>
                    <div className='footerStripBox'>
                        <p>Copyright © 2025 keralaplots. All Rights Reserved.</p>
                    </div>
                    <div className='footerStripBox'>
                        <p>Designed with</p>
                        <LuHeart />
                        <Link to="https://esightsolutions.com/" target='_blank' className='footerStripLogo'>
                            <img src={esightLogo} alt="" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </>
  );
}

export default BuilderProject;
